<template>
    <div class="main_container">
        <el-tabs type="border-card">
            <el-tab-pane label="查看进展">
                <div class="view_mian">
                    <div class="title_sty">申请人基本信息</div>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title"><img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.RequesterName.CheckStatus==0?'showIcon':'hideIcon'">申请人姓名：</div></el-col>
                        <el-col :span="16"><div class="grid-content bg-purple-light info_con">{{dataInfo.RequesterName.NodeValue}}</div></el-col>
                    </el-row>
                     <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title"><img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.RequesterPhoneNum.CheckStatus==0?'showIcon':'hideIcon'">申请人电话：</div></el-col>
                        <el-col :span="16"><div class="grid-content bg-purple-light info_con">{{dataInfo.RequesterPhoneNum.NodeValue}}</div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item" v-if="commitType == 2">
                        <el-col :span="4"><div class="grid-content bg-purple info_title"><img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.RequesterOrganisation.CheckStatus==0?'showIcon':'hideIcon'">所在单位：</div></el-col>
                        <el-col :span="16"><div class="grid-content bg-purple-light info_con">{{dataInfo.RequesterOrganisation.NodeValue}}</div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item" v-if="commitType == 2">
                        <el-col :span="4"><div class="grid-content bg-purple info_title"><img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.PersonIdentification.CheckStatus==0?'showIcon':'hideIcon'">个人身份证明：</div></el-col>
                        <el-col :span="16">
                            <div class="grid-content bg-purple-light info_con" v-for="item in dataInfo.PersonIdentification.NodeValue" :key="item.index" >
                                <div :id="'indexImg_'+item.FileGuid" :ref="'indexImg_'+item.FileGuid">
                                    <ul style="display:inline-block;">
                                        <li style="display:inline-block;" ><span>{{item.FileName}}</span><a class="view_a" target="_blank" id="test" @click="showImgFn(item.FileGuid)">查看<img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+item.FileGuid"></a></li>
                                    </ul>
                                    <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+item.FileGuid" download="个人身份证明" title="下载"  target="_blank" class="download_a">
                                    下载
                                    </a>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <div class="title_sty">待撤文章信息</div>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title"><img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.ArticleName.CheckStatus==0?'showIcon':'hideIcon'">题目名称：</div></el-col>
                        <el-col :span="16"><div class="grid-content bg-purple-light info_con">{{dataInfo.ArticleName.NodeValue}}</div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title"><img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.Author.CheckStatus==0?'showIcon':'hideIcon'">作者：</div></el-col>
                        <el-col :span="16"><div class="grid-content bg-purple-light info_con">{{dataInfo.Author.NodeValue}}</div></el-col>
                    </el-row>
                     <el-row :gutter="10" class="info_item"  v-if="commitType == 2">
                        <el-col :span="4"><div class="grid-content bg-purple info_title"><img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.UnitIdentification.CheckStatus==0?'showIcon':'hideIcon'">单位允许撤除证明：</div></el-col>
                        <el-col :span="20"><div class="grid-content bg-purple-light info_con">
                            <div :id="'indexImg_'+dataInfo.UnitIdentification.NodeValue[0].FileGuid" :ref="'indexImg_'+dataInfo.UnitIdentification.NodeValue[0].FileGuid">
                                <ul style="display:inline-block;">
                                    <li style="display:inline-block;" ><span>{{dataInfo.UnitIdentification.NodeValue[0].FileName}}</span><a class="view_a" target="_blank" id="test" @click="showImgFn(dataInfo.UnitIdentification.NodeValue[0].FileGuid)">查看<img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.UnitIdentification.NodeValue[0].FileGuid"></a></li>
                                </ul>

                                <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.UnitIdentification.NodeValue[0].FileGuid" download="单位允许撤除证明" title="下载"  target="_blank" class="download_a">
                                下载
                                </a>
                            </div>
                            </div>
                            </el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title"><img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.CheckReport.CheckStatus==0?'showIcon':'hideIcon'">检测报告单：</div></el-col>
                        <el-col :span="20"><div class="grid-content bg-purple-light info_con">
                            <!-- {{dataInfo.CheckReport.NodeValue[0].FileName}} -->

                            <div :id="'indexImg_'+dataInfo.CheckReport.NodeValue[0].FileGuid" :ref="'indexImg_'+dataInfo.CheckReport.NodeValue[0].FileGuid">
                                <ul style="display:inline-block;">
                                    <li style="display:inline-block;" ><span>{{dataInfo.CheckReport.NodeValue[0].FileName}}</span><a class="view_a" target="_blank" id="test" @click="showImgFn(dataInfo.CheckReport.NodeValue[0].FileGuid,'pdf')">查看<img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.CheckReport.NodeValue[0].FileGuid"></a></li>
                                </ul>

                                <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.CheckReport.NodeValue[0].FileGuid" download="检测报告单" title="下载"  target="_blank" class="download_a">
                                下载
                                </a>
                            </div>
                            </div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title"><img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.ArticleLocation.CheckStatus==0?'showIcon':'hideIcon'">待撤文章位置：</div></el-col>
                        <el-col :span="20"><div class="grid-content bg-purple-light info_con">
                            <!-- {{dataInfo.ArticleLocation.NodeValue[0].FileName}} -->
                            <div :id="'indexImg_'+dataInfo.ArticleLocation.NodeValue[0].FileGuid" :ref="'indexImg_'+dataInfo.ArticleLocation.NodeValue[0].FileGuid">
                                <ul style="display:inline-block;">
                                    <li style="display:inline-block;" ><span>{{dataInfo.ArticleLocation.NodeValue[0].FileName}}</span><a class="view_a" target="_blank" id="test" @click="showImgFn(dataInfo.ArticleLocation.NodeValue[0].FileGuid)">查看<img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.ArticleLocation.NodeValue[0].FileGuid"></a></li>
                                </ul>

                                <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.ArticleLocation.NodeValue[0].FileGuid" download="待撤文章位置" title="下载"  target="_blank" class="download_a">
                                下载
                                </a>
                            </div>
                            </div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="4"><div class="grid-content bg-purple info_title">申请提交时间：</div></el-col>
                        <el-col :span="20"><div class="grid-content bg-purple-light info_con">{{dataInfo.CreateTime}}</div></el-col>
                    </el-row>
                    <div class="shenhe_box" v-if="dataInfo.ifShenhe==true">
                        <div class="title_sty">审核意见</div>
                        <el-row :gutter="10" class="info_item" v-if="dataInfo.ifShowReview == false">
                            <el-col :span="4"><div class="grid-content bg-purple info_title">审核状态：</div></el-col>
                            <el-col :span="20"><div class="grid-content bg-purple-light info_con">{{dataInfo.CheckStatusText}}</div></el-col>
                        </el-row>
                        <el-row :gutter="10" class="info_item">
                            <el-col :span="4"><div class="grid-content bg-purple info_title">审核意见：</div></el-col>
                            <el-col :span="20"><div class="grid-content bg-purple-light info_con">{{dataInfo.Comment}}</div></el-col>
                            <el-col :span="20" v-if="dataInfo.ifShowReviewTip == true">
                                <div class="grid-content bg-purple-light info_con" style="margin-left: 150px; margin-top: -10px; color: #8b94a7">
                                    （撤稿完成后系统会发送短信通知）
                                </div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10" class="info_item">
                            <el-col :span="4"><div class="grid-content bg-purple info_title">审核时间：</div></el-col>
                            <el-col :span="20"><div class="grid-content bg-purple-light info_con">{{dataInfo.UpdateTime}}</div></el-col>
                        </el-row>
                        <el-button type="primary"  class="reApply_btn" @click="reApply" v-if="dataInfo.ifReCommit==true">重新提交申请</el-button>
                    </div>
                    <div class="chegao_box" v-if="dataInfo.ifZhixing==true">
                        <div class="title_sty">撤除结果</div>
                        <el-row :gutter="10" class="info_item">
                            <el-col :span="4"><div class="grid-content bg-purple info_title">撤除结果：</div></el-col>
                            <el-col :span="20"><div class="grid-content bg-purple-light info_con">{{dataInfo.CheckStatusText}}</div></el-col>
                        </el-row>
                        <el-row :gutter="10" class="info_item">
                            <el-col :span="4"><div class="grid-content bg-purple info_title">结果详情：</div></el-col>
                            <el-col :span="20"><div class="grid-content bg-purple-light info_con">{{dataInfo.ExecuteComment}}</div></el-col>
                        </el-row>
                        <el-row :gutter="10" class="info_item">
                            <el-col :span="4">
                                <div v-if="dataInfo.CheckStatusText == '执行撤除成功'" class="grid-content bg-purple info_title">撤除时间：</div>
                                <div v-else class="grid-content bg-purple info_title">审核时间：</div>
                            </el-col>
                            <el-col :span="20"><div class="grid-content bg-purple-light info_con">{{dataInfo.ExecuteUpdateTime}}</div></el-col>
                        </el-row>
                        <el-button type="primary"  class="reApply_btn" @click="reApply()" v-if="dataInfo.ifReCommit==true">重新提交申请</el-button>

                    </div>
                    <div class="btn_box">
                        <el-button type="primary"  class="backRecord_btn" @click="backRecord">{{BtnText}}</el-button>
                        <!-- <el-button type="primary"  class="reApply_btn" @click="reApply()">重新提交申请</el-button> -->
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
export default {
    data(){
        return{
            viewer3:null,
            authImgUrl:BASE_URL,
            imgUrl:require("../../../assets/images/warn_icon1.png"),
            imgArr:[
                require("../../../assets/images/warn_icon1.png")

                ],
            //imgUrl:"",
            showWran:true,
            paramsData:{
                requestID:"",
                Comment: "",
                UpdateTime: ""
            },
            dataInfo:{
                RequesterName:{
                    NodeValue:""
                },
                RequesterPhoneNum:{
                    NodeValue:""
                },
                RequesterOrganisation:{
                    NodeValue:""
                },
                PersonIdentification:{
                    NodeValue:""
                },
                ArticleName:{
                    NodeValue:""
                },
                Author:{
                    NodeValue:""
                },
                Publication:{
                    NodeValue:""
                },
                PublishTime:{
                    NodeValue:""
                },
                UnitIdentification:{
                    NodeValue:[{FileName:""}]
                },
                CheckReport:{
                    NodeValue:[{FileName:""}]
                },
                ArticleLocation:{
                    NodeValue:[{FileName:""}]
                },
                CreateTime:"",
                ifShenHe:true,
                ifZhixing:false,
                ifReCommit:false,
                requestID:"",
                ExecuteComment: "",
                ExecuteUpdateTime: ""
            },
            pageType:"",
            BtnText:"返回申请记录列表",
            arrAll:[{
                FileGuid:"",
                ClickViewr:""
            }],
            commitType: "", // 1 互联网资源 2 联合比对库资源
            ifShowReview: false, // 是否展示审核状态
            ifShowReviewTip: false // 是否展示审核通过提示
        }
    },
    methods:{
        backRecord(){
            var _this = this;
            if(_this.pageType==2){
                _this.$router.push("/checkedList");
            }else if(_this.pageType==3){
                 _this.$router.push("/dataBase");
            }else{
                _this.$router.push("/applyRecord");
            }

        },
        reApply(){
            var _this = this;
            this.$router.push({
                path:"/reApplyPage",
                name: '重新提交撤除申请',
                params: {
                    id: _this.paramsData.requestID,
                    row: _this.paramsData,
                    type: this.$route.params.type // 1是互联网资源 2是联合比对库资源
                }
            })
        },
        detailGetBysearchParam(request){
            var _this = this;
            _this.$api.detailGetBysearchParam(request).then(res => {
                if(res.data.result){
                    console.log('查看详情res====》', res)
                    var dataList=res.data.info;
                    // dataList.forEach(item => {
                        if(_this.pageType!=1){
                            if(dataList.CheckStatus==0){
                                dataList.ifZhixing=false;
                                dataList.ifShenhe=false;
                                dataList.ifReCommit=false;
                                dataList.CheckStatusText='待审核'
                            }else if(dataList.CheckStatus==-2){
                                dataList.ifShenhe=true;
                                dataList.ifZhixing=true;
                                dataList.ifReCommit=false;
                                dataList.ifShowReview = true
                                dataList.CheckStatusText='执行撤除失败'
                            }else if(dataList.CheckStatus==-1){
                                dataList.ifShenhe=true;
                                dataList.ifZhixing=false;
                                dataList.ifReCommit=true;
                                dataList.ifShowReview = false
                                dataList.CheckStatusText='审核未通过'
                            }else if(dataList.CheckStatus==1){
                                dataList.ifShenhe=true;
                                dataList.ifZhixing=false;
                                dataList.ifReCommit=false;
                                dataList.ifShowReview = false
                                dataList.ifShowReviewTip = true
                                dataList.CheckStatusText='审核通过'
                            }else if(dataList.CheckStatus==2){
                                dataList.ifShenhe=true;
                                dataList.ifZhixing=true;
                                dataList.ifReCommit=false;
                                dataList.ifShowReview = true
                                dataList.CheckStatusText='执行撤除成功'
                            }
                        }else{
                            if(dataList.CheckStatus==0){
                                dataList.ifZhixing=false;
                                dataList.ifShenhe=false;
                                dataList.ifReCommit=false;
                                dataList.CheckStatusText='待审核'
                            }else if(dataList.CheckStatus==-2){
                                dataList.ifShenhe=true;
                                dataList.ifZhixing=true;
                                dataList.ifReCommit=false;
                                dataList.ifShowReview = true
                                dataList.CheckStatusText='执行撤除失败'
                            }else if(dataList.CheckStatus==-1){
                                dataList.ifShenhe=true;
                                dataList.ifZhixing=false;
                                dataList.ifReCommit=true;
                                dataList.ifShowReview = false
                                dataList.CheckStatusText='审核未通过'
                            }else if(dataList.CheckStatus==1){
                                dataList.ifShenhe=true;
                                dataList.ifZhixing=false;
                                dataList.ifReCommit=false;
                                dataList.ifShowReview = false
                                dataList.ifShowReviewTip = true
                                dataList.CheckStatusText='审核通过'
                            }else if(dataList.CheckStatus==2){
                                dataList.ifShenhe=true;
                                dataList.ifZhixing=true;
                                dataList.ifReCommit=false;
                                dataList.ifShowReview = true
                                dataList.CheckStatusText='执行撤除成功'
                            }
                        }
                        if(dataList.Comment==""||dataList.Comment==null||dataList.Comment==undefined){
                            dataList.Comment="无"
                        }
                    // });
                    // console.log('_this.dataInfo', dataList);
                    _this.dataInfo = dataList;
                }else{
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                        duration: 5 * 1000
                    })
                }
            })
        },
        showImgFn(FileGuid,Clicktype){
            if(Clicktype){
                var url = this.authImgUrl+'/api/Common/GetOriginalFile?BatchID='+FileGuid;
                window.open(location.origin+location.pathname+'static/pdf/web/viewer.html?file=' + encodeURIComponent(url))
                return false;
            }
            var _this = this;
            // console.log("_this[FileGuid]=====",_this[FileGuid]);
            var ViewerDom = document.getElementById('indexImg_'+FileGuid);
            // console.log("ViewerDom===",ViewerDom)
            // debugger
            if(!_this[FileGuid]){
                _this[FileGuid] = new Viewer(document.getElementById('indexImg_'+FileGuid), {
                // 相关配置项,详情见下面
                inline: false,  //是否启用 inline 模式
                url: 'data-original',  //设置大图片的 url
                navbar: false,  //显示缩略图导航
                zoomRatio: 0.4,  //鼠标滚动时的缩放比例
                // minZoomRatio:0.01, //最小缩放比例
                // maxZoomRatio:100, //最大缩放比例
                // zIndex:2015, //设置图片查看器 modal 模式时的 z-index
                button: true,  //显示右上角关闭按钮（jQuery 版本无效）
                title: true,  //显示当前图片的标题（现实 alt 属性及图片尺寸）
                keyboard: true,  //是否支持键盘
                movable: true,  //图片是否可移动
                tooltip: true,  //显示缩放百分比
                // rotatable: true,  //图片是否可旋转
                // scalable: true,  //图片是否可翻转
                toolbar: {   //显示工具栏
                    zoomIn: 1,
                    zoomOut: 1,
                    oneToOne: 1,
                    reset: 1,
                    prev: 0,
                    play: 0,
                    next: 0,
                    rotateLeft: 1,
                    rotateRight: 1,
                    flipHorizontal: 1,
                    flipVertical: 1,
                },
                viewed: function () {
                    _this[FileGuid].view(0);
                }
            });
            }

            _this[FileGuid].show();

        }
    },
    mounted(){
        var _this=this;
        // console.log('this.$route.params', this.$route.params)
        if(this.$route.params.id){
            this.paramsData.requestID=this.$route.params.id
            this.paramsData.Comment=this.$route.params.row.Comment
            this.paramsData.UpdateTime=this.$route.params.row.UpdateTime
        }
        _this.$route.meta.activeMenu='/applyRecord'
        if(this.$route.params.pageType){//dataInfo.ifReCommit
            _this.pageType=this.$route.params.pageType;
            _this.dataInfo.ifReCommit=false;
            _this.commitType=this.$route.params.type // 1是互联网资源 2是联合比对库资源
            if(this.$route.params.pageType==2){
                _this.$route.meta.activeMenu='/checkedList'
                _this.BtnText="返回已审核信息列表";
            }else if(this.$route.params.pageType==3){
                _this.$route.meta.activeMenu='/dataBase'
                _this.BtnText="返回数据库";
            }

        }
        this.detailGetBysearchParam(this.paramsData);

    }
}
</script>

<style  scoped>
.view_mian{
    padding:30px 50px
}
.info_item{
    line-height: 40px;
    font-size: 14px;
    color:#606266;
}
.info_title{
    text-align: right;
}
.btn_box{
    margin-left:42%;
}
.reApply_btn{
    padding: 5px 10px;
    margin-bottom: 15px;
    margin-left: 112px;
 }
 .backRecord_btn{
     padding:8px 10px;
 }
 .warn_icon{
     margin-right:5px;
     vertical-align: middle;
 }

</style>



// WEBPACK FOOTER //
// viewRecord.vue?6daa5048